import { fetchWithApiKey } from "../../helpers/fetch";
import { types } from "../../types/types";

export const cfdiUsesStartLoading = () => {
  return async(dispatch) => {
    const resp = await fetchWithApiKey('api/Catalogs/c_UsoCfdi');
    const body = await resp.json();
    if (body.success){
      dispatch( cfdiUsesLoaded( body.data ) )
    }
  }
}

const cfdiUsesLoaded = ( cfdiUses ) => ({
  type: types.cfdiUseStartLoading,
  payload: cfdiUses
})